const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const slides=document.getElementById('hero-slides');
const dots=document.querySelectorAll('.carousel-dot');
let cur=0;let paused=false;
function go(n){cur=n;slides.style.transform='translateX(-'+(n*100)+'%)';dots.forEach((d,i)=>{d.classList.toggle('active',i===n);d.setAttribute('aria-selected',i===n)})}
dots.forEach(d=>d.addEventListener('click',()=>go(+d.dataset.slide)));
const carousel=document.querySelector('.hero-img-carousel');
['mouseenter','focusin'].forEach(ev=>carousel.addEventListener(ev,()=>paused=true));
['mouseleave','focusout'].forEach(ev=>carousel.addEventListener(ev,()=>paused=false));
if(!reduceMotion){setInterval(()=>{if(!paused)go((cur+1)%3)},5000)}
document.addEventListener('keydown',e=>{if(e.target.closest('.hero-img-carousel')||e.target.closest('.carousel-dots')){if(e.key==='ArrowRight')go((cur+1)%3);if(e.key==='ArrowLeft')go((cur-1+3)%3)}});

const track=document.getElementById('reviews-track');
const step=()=>{const c=track.querySelector('.r-card');return c?c.getBoundingClientRect().width+16:356};
document.getElementById('rev-prev').addEventListener('click',()=>track.scrollBy({left:-step(),behavior:reduceMotion?'auto':'smooth'}));
document.getElementById('rev-next').addEventListener('click',()=>track.scrollBy({left:step(),behavior:reduceMotion?'auto':'smooth'}));

const pCards=[...document.querySelectorAll('.p-card')];
const buyBtns=[...document.querySelectorAll('[data-buy-btn]')];
function select(card){pCards.forEach(c=>{const on=c===card;c.classList.toggle('selected',on);c.setAttribute('aria-checked',on);c.tabIndex=on?0:-1});card.focus();const h=card.querySelector('h4');if(scName&&h)scName.textContent=h.textContent;if(scPrice&&card.dataset.price)scPrice.textContent=card.dataset.price;
// Every buy button follows the selected box, so the cart gets what the user picked.
const url=card.dataset.cartUrl;if(url)buyBtns.forEach(b=>b.href=url)}
pCards.forEach((c,i)=>{
  c.addEventListener('click',()=>select(c));
  c.addEventListener('keydown',e=>{
    if(e.key==='ArrowRight'||e.key==='ArrowDown'){e.preventDefault();select(pCards[(i+1)%pCards.length])}
    if(e.key==='ArrowLeft'||e.key==='ArrowUp'){e.preventDefault();select(pCards[(i-1+pCards.length)%pCards.length])}
    if(e.key===' '||e.key==='Enter'){e.preventDefault();select(c)}
  });
});

// Swipe the hero carousel on touch devices
let sx=null,sy=null;
carousel.addEventListener('pointerdown',e=>{sx=e.clientX;sy=e.clientY},{passive:true});
carousel.addEventListener('pointerup',e=>{
  if(sx===null)return;
  const dx=e.clientX-sx, dy=e.clientY-sy;
  if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)){go(dx<0?(cur+1)%3:(cur-1+3)%3)}
  sx=sy=null;
},{passive:true});
carousel.addEventListener('pointercancel',()=>{sx=sy=null},{passive:true});

// Sticky CTA: reveal once the hero CTA has scrolled out of reach
const sticky=document.getElementById('sticky-cta');
const heroCta=document.querySelector('.hero .cta-btn');
if(sticky&&heroCta&&'IntersectionObserver' in window){
  new IntersectionObserver(([e])=>{
    const on=!e.isIntersecting;
    sticky.classList.toggle('show',on);
    sticky.setAttribute('aria-hidden',String(!on));
  },{rootMargin:'0px'}).observe(heroCta);
}
const scName=document.getElementById('sc-name');
const scPrice=document.getElementById('sc-price');

// UGC cards: tap to play with sound, tap again to pause. Only one plays at a time.
const ugcCards=[...document.querySelectorAll('.ugc-card')];
ugcCards.forEach(card=>{
  const vid=card.querySelector('video');
  if(!vid)return;
  card.addEventListener('click',()=>{
    if(vid.paused){
      ugcCards.forEach(o=>{const ov=o.querySelector('video');if(ov&&ov!==vid&&!ov.paused){ov.pause();o.classList.remove('playing')}});
      vid.play();card.classList.add('playing');
    }else{vid.pause();card.classList.remove('playing')}
  });
  vid.addEventListener('ended',()=>{card.classList.remove('playing');vid.currentTime=0});
});

const aTexts=document.querySelectorAll('.announce-text');
let aIdx=0;
setInterval(()=>{aTexts[aIdx].classList.remove('active');aIdx=(aIdx+1)%aTexts.length;aTexts[aIdx].classList.add('active')},5000);

const pQuotes=document.querySelectorAll('.press-quote');
let pqIdx=0;
if(pQuotes.length>1){setInterval(()=>{pQuotes[pqIdx].classList.remove('active');pqIdx=(pqIdx+1)%pQuotes.length;pQuotes[pqIdx].classList.add('active')},6000)}
